import { css, cx } from '@emotion/css';
import { observer } from 'mobx-react-lite';

import { ReactComponent as ArrowLeftIcon } from '^/userWeb/Assets/Icons/arrow-left.svg';
import { ReactComponent as SettingIcon } from '^/userWeb/Assets/Icons/setting.svg';
import { NavigationBar } from '^/userWeb/Components/NavigationBar/NavigationBar';
import { routes } from '^/userWeb/routes';
import { fillParentElem, whiteBackground } from '^/userWeb/styles/commonClasses';

// export const DetectedVisitorsPage: React.FC<{
//   title: string;
//   viewmodel: DetectedVisitorsPageViewModel,
// }> = observer(function DetectedVisitorsPage({}) {

// }

export const StanzoneSimpleLockedPage: React.FC<{
  imageUrl: string,
  minPassed: number,
  altText: string,
}> = observer(function StanzoneSimplePage(p) {
  const title = '🚨스탠존 잠김 알림🚨';

  const isSvg = p.imageUrl.endsWith('.svg');
  return (
    <div
      className={cx(
        fillParentElem, whiteBackground,
      )}
    >
      <NavigationBar
        LeftIcon={ArrowLeftIcon}
        title={title}
        RightIcon={SettingIcon}
        RightIconProps={{
          onClick() {
            routes.notificationSetting({}).push();
          },
        }}
        rootCSS={css`
          height: 60px;
        `}
      />
      <div
        id="StanzoneSimplePageInner"
      >

        {isSvg ? (
          <object
            aria-label={p.altText}
            id="SVGViewer1"
            data={p.imageUrl}
            type="image/svg+xml"
            className={css`
              width: 100%;
            `}
          // className={styles.svgObject}
          >
          </object>
        ) : (
          <img
            src={p.imageUrl}
            alt={p.altText}
          />

        )}

        <h1>스탠존 잠금 경과 {p.minPassed}분 이상!</h1>
        <div>
          스탠존 잠긴지 {p.minPassed} 분 이상 지났습니다!
          <br />
          풀어주시고 소 목이 끼어있는지 확인 바랍니다
        </div>
      </div>
    </div>

  );
});
